<div class="popup-container">
  <header class="popup-header">
    <div class="header-text">
      <h3 class="popup-company">Company: {{ data.entity_name }}</h3>
      <h4 class="popup-theme">Theme: {{ data.theme_label }}</h4>
      <p class="popup-description" *ngIf="view === 'activity'">
        Innovation activity of {{ data.entity_name }} in "{{ data.theme_label }}" over the last 10 years.
      </p>
      <p class="popup-description" *ngIf="view === 'inventions'">
        Most recent inventions (patent families) owned by {{ data.entity_name }} in "{{ data.theme_label }}". Adjust dates or quality score to refine.
      </p>
    </div>

    <div class="header-actions">
      <div class="view-toggle">
        <button type="button" class="toggle-btn"
          [class.active]="view === 'activity'"
          (click)="showActivity()" matTooltip="View Innovation Activity">
          <i class="bi bi-graph-up"></i><span>Activity</span>
        </button>
        <button type="button" class="toggle-btn"
          [class.active]="view === 'inventions'"
          (click)="showInventions()" matTooltip="View Inventions">
          <i class="bi bi-lightbulb"></i><span>Inventions</span>
        </button>
      </div>
      <button class="close-btn" (click)="close()" matTooltip="Close">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
  </header>

  <div class="popup-content">
    <div [hidden]="view !== 'activity'">
      <app-company-theme-activity-graph
        [tabId]="data.tabId"
        [entityid]="data.entityid"
        [entity_name]="data.entity_name"
        [theme_label]="data.theme_label"
        [theme_search_type]="data.theme_search_type"
        [cluster_id]="data.cluster_id ?? null"
        [cluster_name]="data.cluster_name ?? null"
        [query]="data.query ?? null">
      </app-company-theme-activity-graph>
    </div>

    <div [hidden]="view !== 'inventions'">
      <app-inventions-view
        [isPopup]="true"
        [popupCompanyName]="data.entity_name"
        [popupTheme]="data.theme_label"
        [tabId]="data.tabId"
        [tab_name]="data.entity_name"
        [query]="data.query ?? null"
        [entityids]="[data.entityid]"
        [theme_search_type]="data.theme_search_type"
        [cluster_id]="data.cluster_id ?? null"
        [cluster_name]="data.cluster_name ?? null">
      </app-inventions-view>
    </div>
  </div>
</div>
